import React, { useState } from "react";
import Personal from "../../../components/forms/Settings/Personal";
import Form from '../../../components/forms/utils/Form';
import SettingsCard from './SettingsCard';
import { UPDATE_USER } from '../../../utils/api/user';
import { useMutation } from '@apollo/client';
import { useCurrentUser } from '../../../utils/CurrentUserContext';

const AdvancedProfile = () => {
  const {user} = useCurrentUser()
  const [editCompany, setEditCompany] = useState(false);
  const [updateUser] = useMutation(UPDATE_USER)

  const handleSubmit = (_, dirtyValues) => {
    updateUser({ variables: { id: user._id, record: dirtyValues } })
  };

  return (
    <SettingsCard title="Profile details">
      <Form
        submitButtonText="Save"
        onSubmit={handleSubmit}
        defaultValues={{
          firstname: user.firstname,
          lastname: user.lastname,
          avatarUrl: user.avatarUrl,
          title: user.title
        }}
      >
        <Personal edit={editCompany} setEditCompany={setEditCompany} />
      </Form>
    </SettingsCard>
  );
};

export default AdvancedProfile;
